import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { QueryKeys } from "@/queries/utils";

export const rejectionReasons = [
  "Compensation",
  "Requirements or skill mismatch",
  "Too many hours",
  "Too few hours",
  "Start date doesn't align",
  "Lack of industry fit",
  "Lack of availability",
];

interface RejectCandidateParams {
  openingId: string;
  candidateStatusId: string;
  declineReasons: (typeof rejectionReasons)[number][];
  otherDeclineReason?: string;
}

export const useRejectCandidate = () => {
  const qc = useQueryClient();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async ({
      openingId,
      candidateStatusId,
      declineReasons,
      otherDeclineReason,
    }: RejectCandidateParams) => {
      const token = await getAccessTokenSilently();

      await request({
        method: "POST",
        path: `/api/jobOpening/${openingId}/candidate/${candidateStatusId}/reject`,
        token,
        body: JSON.stringify({
          declineReasons,
          otherDeclineReason,
        }),
      });
    },
    onSettled: async (_, __, { openingId }) => {
      await qc.invalidateQueries({
        queryKey: QueryKeys.companyOpportunities,
      });

      await qc.invalidateQueries({
        queryKey: QueryKeys.companyOpportunity(openingId),
      });
    },
  });

  return {
    rejectCandidate: mutate,
    isRejecting: isPending,
    rejectError: error,
  };
};
